import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as SmartyStreetsSDK from 'smartystreets-javascript-sdk';

/**
 * @classdesc Address Qualification
 * method that returns a promise that resolves with address options based on the given input
 */
var AddressQualification = /*#__PURE__*/function () {
  /**
   * @param {string} smartyStreetsWebsiteKey - string of numbers that represents the key Smarty Streets SDK needs
   */
  function AddressQualification(_ref) {
    var smartyStreetsWebsiteKey = _ref.smartyStreetsWebsiteKey;
    _classCallCheck(this, AddressQualification);
    this.SmartyStreetsCore = SmartyStreetsSDK.core;
    this.SmartyStreetsAutoLookup = SmartyStreetsSDK.usAutocomplete.Lookup;
    this.SmartyStreetsStreetLookup = SmartyStreetsSDK.usStreet.Lookup;
    this.WebsiteKey = smartyStreetsWebsiteKey;
    this.credentials = new this.SmartyStreetsCore.SharedCredentials(this.WebsiteKey);
    this.AutoClient = this.SmartyStreetsCore.buildClient.usAutocomplete(this.credentials);
    this.AddressClient = this.SmartyStreetsCore.buildClient.usStreet(this.credentials);
  }

  /**
   * Hits the Smart Streets endpoint using the SDK and returns the results for a Select Dropdown
   * @param {string} query - string representing the text the user is inputting for their address
   * @return {array} - returns an array of objects containing the closest address matches to the give query
   */
  return _createClass(AddressQualification, [{
    key: "autofillSuggestions",
    value: function autofillSuggestions(query) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if (!_this.WebsiteKey) {
          reject(new Error('Leshen:UI:AddressQualification - no smartyStreetsWebsiteKey used in intialization'));
        }
        var lookup = new _this.SmartyStreetsAutoLookup(query);
        _this.AutoClient.send(lookup).then(function (data) {
          resolve(data.result.map(function (s) {
            return {
              label: s.text,
              value: s.text
            };
          }));
        })["catch"](function (err) {
          return reject(new Error("Leshen:UI:AddressQualification - error pulling street suggestions from Smarty Streets: ".concat(err)));
        });
      });
    }
  }]);
}();
var AddressQualification$1 = AddressQualification;

export { AddressQualification$1 as default };
//# sourceMappingURL=AddressQualification.js.map
